// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__le3ci","col":"Table_col__2E6Xr","fulfillmentStatus":"Table_fulfillmentStatus__1Marw","emailCol":"Table_emailCol__2po3J"};